// Add your custom JS here.


document.querySelectorAll('.text-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('p').forEach(p => {
      const content = p.innerHTML.trim();
      if (content === '&nbsp;' || content === '') {
        p.remove();
      }
    });
  });
  
document.querySelectorAll('.accordion-body').forEach(wrapper => {
    wrapper.querySelectorAll('p').forEach(p => {
      const content = p.innerHTML.trim();
      if (content === '&nbsp;' || content === '') {
        p.remove();
      }
    });
  });
  

  document.addEventListener('DOMContentLoaded', function () {
    const videoWrappers = document.querySelectorAll('.video-wrapper');
  
    videoWrappers.forEach(videoWrapper => {
      const playButton = videoWrapper.querySelector('.video-btn');
      const videoCoverWrapper = videoWrapper.querySelector('.video-cover-wrapper');
      const videoElement = videoWrapper.querySelector('.video-element');
  
      if (playButton && videoCoverWrapper && videoElement) {
        playButton.addEventListener('click', function () {
          // Hide the cover
          videoCoverWrapper.style.display = 'none';
          // Show the video container
          videoElement.style.display = 'block';
  
          const iframe = videoElement.querySelector('iframe');
          const video = videoElement.querySelector('video');
  
          if (iframe) {
            // It's an iframe (e.g., YouTube)
            const src = iframe.getAttribute('src');
            if (!src.includes('autoplay=1')) {
              const connector = src.includes('?') ? '&' : '?';
              iframe.setAttribute('src', src + connector + 'autoplay=1');
            }
          } else if (video) {
            // It's a native <video>
            video.muted = false;
            video.play();
          }
        });
      }
    });
  });
  










  document.addEventListener("DOMContentLoaded", function () {
    const select = document.getElementById("brand-select");

    fetch("/wp-admin/admin-ajax.php?action=get_brand_list")
        .then(res => res.json())
        .then(json => {
            if (!json.success) throw new Error("API failed");
            json.data.forEach(brand => {
                const option = document.createElement("option");
                option.value = brand;
                option.textContent = brand;
                select.appendChild(option);
            });
        })
        .catch(err => {
            console.error("Failed to load brand list:", err);
        });
});






// jQuery('[data-moburl]').on('click', function (e) {
//   // Prevent default on mobile only (less than 768px) and go to the attribute data-moburl
//   if (window.innerWidth < 768) {
//     e.preventDefault();
//     const url = jQuery(this).data('moburl');
//     if (url) {
//       window.location
//         .assign(url);
//     }
//   }
// }
// );


if(jQuery('.stickinpar').length) {
jQuery('.stickinpar').stick_in_parent({
 offset_top: jQuery('.navbar').outerHeight() + 20,
 recalc_every: 5
});
}







function validateField(field) {
  const isValid = field.value.trim() !== '';
  field.classList.toggle('isvaliditem', isValid);
}

document.addEventListener('DOMContentLoaded', () => {
  const fields = document.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], select');

  fields.forEach(field => {
    ['keyup', 'change'].forEach(eventType => {
      field.addEventListener(eventType, () => validateField(field));
    });

    // Initial validation on page load (optional)
    validateField(field);
  });
});
